import { axiosInstance } from '@meterup/common';

export const axiosInstanceJSON = axiosInstance;
